export default __webpack_public_path__ + "232434cfb50a11042952ae8d3e74e439.png";